import React, { useEffect } from 'react';
import fingers from '../components/assets/branding/2fingers.png';
import './css/checkoutSuccess.css';

const CheckoutSuccess = () => {
    useEffect(() => {
        // Clear cart from local storage on successful checkout
        localStorage.removeItem("guestCart");
    }, []);

    return (
        <div className='success-page'>
            <img src={fingers} className='fingers' alt="" />
            <h2>Thank you</h2>
            <h3>you really are a bastard!</h3>
            <p>Your order is being prepared. Login to check any changes in order status.</p>
        </div>
    );
};

export default CheckoutSuccess;
